/**
 * The site's domain name.
 */
export const DOMAIN_NAME = 'fiverr.com';

/**
 * The default path of cookie.
 */
export const DEFAULT_PATH = '/';
